import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import { db } from '../../firebase'



function EventHeld() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(34);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [notice, setNotice] = useState([])
    const navigate = useNavigate()

    const noticeCollectionRef = collection(db, "Event Held");
    useEffect(() => {

        const getNotice = async () => {
            const data = await getDocs(noticeCollectionRef);
            setNotice(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getNotice()
    }, [])
    return (

        <>



            {notice.filter((val) => {
                if (setsearchTerm === "") {
                    return val;
                } {
                    return val;
                }
            }).slice(pagination.start, pagination.end).map((krishnagarpublicschool) => {
                return (




                    <div className="card-body">
                        <marquee scrollamount="1" direction="up">
                            <h5 style={{ color: "#1D4D93" }} className="card-text mb-3"> {krishnagarpublicschool.event1}</h5>
                            <h5 style={{ color: "#1D4D93" }} className="card-text"> {krishnagarpublicschool.event2}</h5>
                            <h5 style={{ color: "#1D4D93" }} className="card-text"> {krishnagarpublicschool.event3}</h5>

                        </marquee>






                    </div>

                )
            })}



        </>

    );
}

export default EventHeld;